import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ISymbolSizeConfig, ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {AvalancheZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/AvalancheZeroBetController";
import {FreespinAvalancheZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinAvalancheZeroBetController";
import {GGFontConfig} from "./GGFontConfig";
import {GGGameAssets} from "./GGGameAssets";
import {GGGameConfig} from "./GGGameConfig";
import {GGSoundConfig} from "./GGSoundConfig";
import {GGServerDataParser} from "./server/GGServerDataParser";
import {GGParsedGameData} from "./server/data/GGParsedGameData";
import {GGParsedInitData} from "./server/data/GGParsedInitData";
import {GGReelSymbolStateCreator} from "./symbols/GGReelSymbolStateCreator";
import {GGBigWinController} from "./winpresentation/bigwin/GGBigWinController";
import {GGInitialWPController} from "./winpresentation/initial/GGInitialWPController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {WaysAndMultiplier} from "./waysandmultiplier/WaysAndMultiplier";
import {GGBackground} from "./background/GGBackground";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {GGReelController} from "./reel/GGReelController";
import {GGReelPartAnimator} from "./reel/GGReelPartAnimator";
import {AvalancheReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheReelPartAnimator";
import {AvalancheReelController} from "@nolimitcity/slot-game/bin/game/reel/avalanchereel/AvalancheReelController";
import {GGReelSymbolH} from "./symbols/GGReelSymbolH";
import {GGReelSymbolM} from "./symbols/GGReelSymbolM";
import {GGReelSymbol} from "./symbols/GGReelSymbol";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {GGFreespinOutroView} from "./screen/freespinoutro/GGFreespinOutroView";
import {GGFreespinOutroController} from "./screen/freespinoutro/GGFreespinOutroController";
import {ScatterAttention} from "./reelstoppresentation/ScatterAttention";
import {GGSoundPlayer} from "./soundplayer/GGSoundPlayer";
import {ScatterWin} from "./winpresentation/addfsscreendelay/ScatterWin";
import {FreespinNoWinPause} from "./reelstoppresentation/FreespinNoWinPause";
import {GGReels} from "./reelarea/GGReels";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {GGReelAreaView} from "./reel/GGReelAreaView";
import {GGReelView} from "./reel/GGReelView";
import {GGFreespinZeroBetController} from "./zerobet/GGFreespinZeroBetController";
import {GGSuperFreespinIntroController} from "./screen/freespinintro/GGSuperFreespinIntroController";
import {GGFreeSpinIntroView} from "./screen/freespinintro/GGFreeSpinIntroView";
import {GGReelSymbolZ} from "./symbols/GGReelSymbolZ";
import {DeadWildTransform} from "./winpresentation/deadwildtransform/DeadWildTransform";
import {Eviel4Presentation} from "./evil4presentation/Eviel4Presentation";
import {BankBrokeController} from "./screen/bankbroke/BankBrokeController";
import {BankBrokeView} from "./screen/bankbroke/BankBrokeView";
import {FSCounter} from "./fscounter/FSCounter";
import {GGReelSymbolL} from "./symbols/GGReelSymbolL";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {GoblinSpell} from "./reelstoppresentation/GoblinSpell";
import {SymbolLanding} from "./reelstoppresentation/SymbolLanding";
import {GGIndividualWPController} from "./winpresentation/individual/GGIndividualWPController";
import {GrenadePresentation} from "./grenadepresentation/GrenadePresentation";
import {GGReelSymbolW} from "./symbols/GGReelSymbolW";
import {DoubleBombSpinIntroController} from "./beforespinstoppresentationcontroller/doublebombspinintro/DoubleBombSpinIntroController";
import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {GGDoubleBombZeroBetController} from "./zerobet/GGDoubleBombZeroBetController";
import {RandomBuyIntroController} from "./beforespinstoppresentationcontroller/randombuyintro/RandomBuyIntroController";
import {GGBigWinCountUp} from "./winpresentation/bigwin/GGBigWinCountUp";
import {UpgradeFSIntro} from "./winpresentation/upgradefsintro/UpgradeFSIntro";
import {GGDoubleBombAvalancheZeroBetController} from "./zerobet/GGDoubleBombAvalancheZeroBetController";
import {BombPresentation} from "./winpresentation/bomb/BombPresentation";
import {PatchEvil4Multiplier} from "./reelstoppresentation/PatchEvil4Multiplier";
import {DeadWildAttention} from "./deadwildattention/DeadWildAttention";
import {GGSpinController} from "./spin/GGSpinController";
import {FeaturePrice} from "./utils/FeaturePrice";

export class GGGameModuleConfig implements IGameModuleConfig {

    public static instance:GGGameModuleConfig = new GGGameModuleConfig();
    public static background:GGBackground;
    public static betWaysOnReel:WaysAndMultiplier;
    public static soundPlayer:GGSoundPlayer;
    public static topTrain:Eviel4Presentation;
    public static fsCounter:FSCounter;
    public static grenadePresentation:GrenadePresentation;
    public static bigWinCountUp:GGBigWinCountUp;
    public static scatterAttention: ScatterAttention;
    public static deadWildAttention: DeadWildAttention;
    public static patchEvil4Multiplier: PatchEvil4Multiplier;
    public static featurePrice: FeaturePrice;

    GAME_CONFIG:IGameConfig = GGGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = GGSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = GGFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = GGGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => {
        return new GGServerDataParser();
    };
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => {
        return new GGParsedInitData(data, <GGServerDataParser>dataParser);
    };
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => {
        return new GGParsedGameData(data, <GGServerDataParser>dataParser);
    };

    REEL_AREA_VIEW:() => ReelAreaView = () => {
        return new GGReelAreaView();
    };

    SPIN_CONTROLLER?:() => GGSpinController = () => {
        return new GGSpinController();
    };

    REELS:() => Reels = () => {
        return new GGReels();
    };

    REEL_CONTROLLER:(reelId:number) => AvalancheReelController = reelId => {
        return new GGReelController(reelId);
    };

    REEL_VIEW:(reelId:number) => PIXI.Container = (reelId:number) => {
        return new GGReelView();
    };

    REEL_PART_ANIMATOR:(reelId:number) => AvalancheReelPartAnimator = (reelId) => {
        return new GGReelPartAnimator(reelId);
    };

    REEL_PART_CREATOR:() => ReelPartCreator = () => {
        return new ReelPartCreator(
            (symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig):GGReelSymbol => {
                const symGroup:string = symName[0];
                if(symGroup==="L") {
                    return new GGReelSymbolL(symName, reelId, state, size);
                }else if(symGroup==="M") {
                    return new GGReelSymbolM(symName, reelId, state, size);
                }else if(symGroup==="Z") {
                    return new GGReelSymbolZ(symName, reelId, state, size);
                }else if(symGroup==="W") {
                    return new GGReelSymbolW(symName, reelId, state, size);
                }
                //S,B,W
                return new GGReelSymbolH(symName, reelId, state, size);
            });
    };

    SYMBOL_STATE_CREATOR:() => ReelSymbolStateCreator = () => {
        return new GGReelSymbolStateCreator();
    };

    SCREENS:(() => ScreenController)[] = [
        () => {
            return new GGSuperFreespinIntroController({
                viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                    return new GGFreeSpinIntroView({
                        layer : GGGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                        onButtonClickCallback : onButtonClickCallback,
                        mobileScale : 1,
                        portraitScale : 1
                    }, autoClose);
                }
            });
        },
        () => {
            return new GGFreespinOutroController({
                viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                        return new GGFreespinOutroView({
                            layer : GGGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                              onButtonClickCallback : onButtonClickCallback,
                        mobileScale : 1,
                        portraitScale : 1
                    }, autoClose);
                }
            });
        },
       () => {
           return new BankBrokeController({
               viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                   return new BankBrokeView({
                       layer : GGGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                       onButtonClickCallback : onButtonClickCallback,
                       mobileScale : 1,
                       portraitScale : 1
                   }, false);
               }
           });
       }
    ];

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new GGDoubleBombZeroBetController(),
        () => new GGDoubleBombAvalancheZeroBetController(),
        () => new AvalancheZeroBetController(),
        () => new GGFreespinZeroBetController(),
        () => new FreespinAvalancheZeroBetController()
    ];

    BEFORE_SPIN_STOP_PRESENTATIONS:((index:number) => BeforeSpinStopPresentationController)[] = [
        index => new DoubleBombSpinIntroController(index),
        index => new RandomBuyIntroController(index)
    ];
    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        index => new SymbolLanding(index),
        index => new FreespinNoWinPause(index),
        index => new ScatterAttention(index),
        index => new GoblinSpell(index)
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new BombPresentation(indexes)],
        [indexes => new DeadWildTransform(indexes)],
        [indexes => new GGInitialWPController(indexes)],
        [indexes => new GGBigWinController(indexes)],
        [indexes => new ScatterWin(indexes)],
        [indexes => new UpgradeFSIntro(indexes)]
    ];

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => {
        return new GGIndividualWPController({
            symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
                return 0;
            }
        });
    };

    GAME_FEATURE_CREATOR:() => void = () => {
        //const idleAnimation:BackgroundIdleAnimation = new BackgroundIdleAnimation({
        //    startTime : 3,
        //    minInterval : 15,
        //    maxInterval : 30
        //});
        //const midSymbolIdleAnimation = new GGMSymbolIdleAnimationController({
        //    startTime : 0,
        //    minInterval : 150,
        //    maxInterval : 250
        //});
        GGGameModuleConfig.background = new GGBackground({
            layer : GGGameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {image : GGGameAssets.MAIN_GAME_BACKGROUND},
                SUPER_FREESPIN : {image : GGGameAssets.FS_GAME_BACKGROUND},
                FREESPIN : {image : GGGameAssets.FS_GAME_BACKGROUND},
                NORMAL_AVALANCHE : {
                    image : GGGameAssets.MAIN_GAME_BACKGROUND
                },
                DOUBLE_BOMB : {
                    image : GGGameAssets.MAIN_GAME_BACKGROUND
                },
                FREESPIN_AVALANCHE : {
                    image : GGGameAssets.FS_GAME_BACKGROUND
                }
            },
            stretch : false
        });

        GGGameModuleConfig.soundPlayer = new GGSoundPlayer();
        GGGameModuleConfig.betWaysOnReel = new WaysAndMultiplier();
        GGGameModuleConfig.topTrain = new Eviel4Presentation();
        GGGameModuleConfig.fsCounter = new FSCounter();
        GGGameModuleConfig.grenadePresentation = new GrenadePresentation();
        GGGameModuleConfig.deadWildAttention = new DeadWildAttention();
        GGGameModuleConfig.patchEvil4Multiplier = new PatchEvil4Multiplier();
        GGGameModuleConfig.featurePrice = new FeaturePrice();
    };

    constructor() {
        if(GGGameModuleConfig.instance) {
            throw new Error("GGGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}